<template>
  <div class="col-12 sector product-sector px-3">
    <div class="row">
      <!-- header -->
      <div class="col-12">
        <div class="product-sector__header py-3" @click="toggleProductSection" :checked="state.check_all">
          <div class="product-sector__text">
            {{ t("carts.currentlySelected") }}
            <span class="product-sector__highlight-text">{{ cartCount }}</span>
            {{ $t("carts.items", cartCount) }}
          </div>
          <div class="product-sector__collapse">
            <i class="bi" :class="state.show ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </div>
        </div>
      </div>

      <div class="col-12 product-sector__content" :class="{'open': state.show }">
        <div v-for="(g, gk) in cartGroupsFormatted">
          <template v-if="gk !== 'unchecked'">
            <!-- group header -->
            <div class="product-sector__group-title">{{ g.cart_group_name }}</div>
            <!-- table header -->
            <div class="col-12">
              <div class="product-sector__table-header d-none d-lg-block">
                <div class="table-head-sector">
                  <div class="table-head-title">{{ t("orders.productDetails") }}</div>
                  <div class="table-head-title">{{ t("orders.qty") }}</div>
                  <div class="table-head-title">{{ t("orders.price") }}</div>
                  <div class="table-head-title">&nbsp;</div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <!-- productItem -->
              <div v-for="n in g.items"
                class="product-group"
                :key="n.cart_id"
              >
                <div class="product-group__content">
                  <div class="product-item row">
                    <div class="col-3 col-sm-2 product-item__col product-item__col--left">
                      <div class="product-item__img">
                        <img class="lazyload" :src="n.image_url" style="width:150px; height:150px">
                      </div>
                    </div>
                    <div class="col-9 col-sm-10 product-item__col product-item__col--right">
                      <div class="row">
                        <!-- 名稱 -->
                        <div class="col-12 col-lg-5 product-item__name">
                          <div class="product-item__name-main">
                            <span>{{ n.product_name }}</span>
                          </div>
                          <div class="product-item__name-sub">
                            <span>{{ n.symbol }} {{ n.sale_price }} - {{ n.assort_name }}</span>

                            <!-- 數量 -->
                            <span class="product-item__qty d-lg-none">x {{ n.quantity }}</span>
                          </div>
                        </div>

                        <!-- 數量 -->
                        <div class="col-12 col-lg-3 product-item__qty d-none d-lg-block">
                          <span>{{ n.quantity }}</span>
                        </div>

                        <!-- 金額 -->
                        <div class="col-12 col-lg-2 product-item__total-price">
                          <span>{{ n.symbol }} {{ n.sale_price * n.quantity }}
                          </span>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 offset-md-5 product-sector__group-calc">
              <div class="total-price-calc-sector">
                <div class="total-price-calc__total">
                  <div>{{ t("orders.subtotal") }}</div>
                  <div><span>{{ state.currency_symbol }} {{ currencyFormat(g.assort_org_total) }}</span></div>
                </div>

                <div class="total-price-calc__total">
                  <div>{{ t("orders.deliveryFees") }}</div>
                  <div><span>{{ state.currency_symbol }} {{ currencyFormat(g.delivery_fees) }}</span></div>
                </div>

                <div v-if="g.delivery_fees_discount > 0" class="total-price-calc__total">
                  <div>{{ t("orders.deliveryFeesDiscount") }}</div>
                  <div><span>- {{ state.currency_symbol }} {{ currencyFormat(g.delivery_fees_discount) }}</span></div>
                </div>

                <div v-if="g.assort_discount > 0" class="total-price-calc__total">
                  <div>{{ t("orders.assortDiscount") }}</div>
                  <div><span>- {{ state.currency_symbol }} {{ currencyFormat(g.assort_discount) }}</span></div>
                </div>
                <div v-if="g.prom_discount > 0" class="total-price-calc__total">
                    <div>{{ t("orders.promDiscount") }}</div>
                    <div><span>- {{ state.currency_symbol }} {{ currencyFormat(g.prom_discount) }}</span></div>
                </div>

                <div class="total-price-calc__total" v-if="logisticMap[g.logistic_type] && logisticMap[g.logistic_type].show_description_on_checkout">
                  <p class="hint">{{ logisticMap[g.logistic_type].description }}</p>
                </div>

                <div class="total-price-calc__total">
                  <div>{{ t("orders.total") }}</div>
                  <div><span>{{ state.currency_symbol }} {{ groupTotal(g) }}</span></div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel, useVModels } from '@vueuse/core'
import { currencyFormat } from "../../utils"

const props = defineProps({
  state: Object,
  form: Object,
  data: Object,
  logisticMap: Object,
  cartGroupsFormatted: Object,
})
const emit = defineEmits(['update:state', 'update:form'])

const { t, locale } = useI18n()
const { state, form } = useVModels(props, emit)

const cartCount = computed(() => form.value.carts.reduce((count, cart) => (count += cart.checked?cart.quantity:0), 0));

const toggleProductSection = () => {
  state.value.show = !state.value.show
}
const groupTotal = (g) => {
  let total = g.assort_org_total + g.delivery_fees - g.delivery_fees_discount - g.assort_discount - g.prom_discount
  
  return currencyFormat(total)
}
</script>
